import { createContext, useContext } from 'react';
import type {
    AirBnBIntegrationConfig,
    CleaningConfig,
    LockboxConfig,
    TourismTaxConfig,
} from '../../../../../packages/entities/Property';
import type { ModuleId } from '../modules/registry';

export type Property = {
    id: number;
    name: string;
    minNights: number;
    weekStartDay: 0 | 1;
    currency: string;
    modules: Record<string, unknown>;
    taxPresetId: string | null;
    created: string;
    updated: string;
};

type PropertyContextType = {
    propertyId?: number;
    property?: Property;
    isModuleEnabled(moduleId: ModuleId): boolean;
    isAirBnBEnabled(): boolean;
    getAirBnBConfig(): AirBnBIntegrationConfig | undefined;
    isTourismTaxEnabled(): boolean;
    getTourismTaxConfig(): TourismTaxConfig | undefined;
    isLockboxEnabled(): boolean;
    getLockboxConfig(): LockboxConfig | undefined;
    isCleaningEnabled(): boolean;
    getCleaningConfig(): CleaningConfig | undefined;
    isSzamlazzEnabled(): boolean;
    loading?: boolean;
};

const PropertyContext = createContext<PropertyContextType>({
    isModuleEnabled: () => false,
    isAirBnBEnabled: () => false,
    getAirBnBConfig: () => undefined,
    isTourismTaxEnabled: () => false,
    getTourismTaxConfig: () => undefined,
    isLockboxEnabled: () => false,
    getLockboxConfig: () => undefined,
    isCleaningEnabled: () => false,
    getCleaningConfig: () => undefined,
    isSzamlazzEnabled: () => false,
});

export const PropertyProvider = PropertyContext.Provider;

const useProperty = () => {
    return useContext(PropertyContext);
};

export default useProperty;
